import { render, staticRenderFns } from "./archivingDetail.vue?vue&type=template&id=5e47315b&scoped=true&"
import script from "./archivingDetail.vue?vue&type=script&lang=js&"
export * from "./archivingDetail.vue?vue&type=script&lang=js&"
import style0 from "./archivingDetail.vue?vue&type=style&index=0&id=5e47315b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47315b",
  null
  
)

export default component.exports